/* eslint-disable react/prop-types */
import React from 'react'

import Layout from '~components/SecondaryLayout'
import S from '~components/seo'
import HighlightsCard from '~components/HighlightsCard'
import Ecosystem from '~components/Ecosystem'
import Roadmap from '~components/Roadmap'
import SubNav from '~components/SubNav'
import DATA from '~containers/Project/constants'
import SubNavMenu from '~hooks/useSubNavMenu'

import video from '~img/hero/xcad-app-v2.mp4'
import SectionBlog from './components/SectionBlog'

const HeroHeader = ({ className }) => (
  <div className={className}>
    <p className="text-black font-medium text-xs md:text-xl w-fit uppercase">
      The
    </p>

    <h1 className="bg-gradient-primary font-semibold text-4xl md:text-7xl leading-none uppercase">
      Creator <br /> Token
    </h1>
    <p className="font-medium text-black text-2xl  md:text-4xl uppercase">
      Revolution
    </p>
  </div>
)

const Hero = () => (
  <div className="max-w-[1360px] px-6 sm:px-2 md:px-10 w-full my-8">
    <div className="flex flex-col-reverse md:flex-row justify-between">
      <div
        className="flex flex-col justify-center gap-8"
        data-sal="slide-right"
        data-sal-delay="500"
        data-sal-easing="ease-out-back"
        data-sal-duration="2000"
      >
        <HeroHeader className="hidden md:inline-block" />

        <p className="font-normal text-lg text-primary w-full md:max-w-lg mt-3 md:mt-0">
          Earn directly on YouTube from watching your favourite Creators.
          Launching Creator Tokens for global YouTube Stars.
        </p>

        <p className="font-semibold text-xl md:text-2xl text-primary">
          Creators Launch Tokens, Fans Connect & Earn!
        </p>
      </div>

      <div
        id="heroImg"
        data-sal="slide-up"
        data-sal-delay="100"
        data-sal-easing="ease-out-back"
        data-sal-duration="2000"
      >
        <HeroHeader className="flex flex-col justify-center items-center text-center md:hidden pb-6" />
        <video
          src={video}
          autoPlay
          loop
          muted
          tabIndex={-1}
          className="shadow-xl h-auto md:h-full w-full rounded-xl border border-gray-300"
        />
      </div>
    </div>
  </div>
)

const Homepage = () => {
  const { heroSubNav } = DATA
  const { showSubNav, mainMenuRef } = SubNavMenu()
  return (
    <>
      {showSubNav && (
        <SubNav data={heroSubNav} variant="top" className="hidden md:block" />
      )}
      <S title="Home" />
      <Layout
        heroChildren={
          <>
            <SubNav data={heroSubNav} />
            <div ref={mainMenuRef} />
            <Hero />
          </>
        }
      >
        <HighlightsCard id="backers" />
        <Ecosystem />
        <Roadmap id="roadmap" />
        <SectionBlog id="news" />
      </Layout>
    </>
  )
}

export default Homepage
